import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Box, Typography } from '@mui/material';
import AccountBalanceOutlinedIcon from '@mui/icons-material/AccountBalanceOutlined';
import ContentArea from '../components/content-area/Content';
import AdvertiserBrandList from '../components/advertisers/AdvertiserBrandList';
import FinanceSpaceSelector from '../components/finance/FinanceSpaceSelector';
import CampaignOutlinedIcon from '@mui/icons-material/CampaignOutlined';
import { usePermissions } from '../hooks/usePermissions';
import { useSessionState } from '../hooks/useSessionState';

const Advertisers = () => {
  const navigate = useNavigate();
  const { isFinanceMode } = usePermissions();
  const [selectedSpace, setSelectedSpace] = useSessionState('tifoxr_finance_space_advertisers', null);

  const handleSpaceSelect = (space) => setSelectedSpace(space);

  return (
    <ContentArea
      title="Advertisers"
      icon={<CampaignOutlinedIcon sx={{ fontSize: { xs: 20, sm: 24, md: 28 } }} />}
      container={false}
    >
      {isFinanceMode && (
        <FinanceSpaceSelector
          selectedSpaceId={selectedSpace?.spaceId ?? null}
          onSpaceSelect={handleSpaceSelect}
        />
      )}

      {isFinanceMode ? (
        selectedSpace ? (
          <AdvertiserBrandList
            key={selectedSpace.spaceId}
            onSelectBrand={(brand) =>
              navigate(`/advertisers/${brand.id}`, { state: { advertiser: brand, overrideSpaceId: selectedSpace.spaceId } })
            }
            overrideSpaceId={selectedSpace.spaceId}
          />
        ) : (
          <Box sx={{ textAlign: 'center', py: 10, display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 2 }}>
            <AccountBalanceOutlinedIcon sx={{ fontSize: 56, color: '#a7f3d0' }} />
            <Typography variant="body1" sx={{ color: '#94a3b8', fontWeight: 500 }}>
              Select a space above to view advertisers
            </Typography>
          </Box>
        )
      ) : (
        <AdvertiserBrandList
          onSelectBrand={(brand) =>
            navigate(`/advertisers/${brand.id}`, { state: { advertiser: brand } })
          }
        />
      )}
    </ContentArea>
  );
};

export default Advertisers;
